import { Link } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function NotFound() {
  useDocumentTitle("404 – nie znaleziono", "Ta strona nie istnieje.");
  return (
    <div className="min-h-screen bg-[#FDFBF7] grid place-items-center px-6">
      <div className="text-center">
        <div className="font-display text-[120px] leading-none text-[#E6007A]">404</div>
        <h1 className="font-display text-3xl mt-4 mb-6">Ta strona zaginęła w drodze do kawiarni.</h1>
        <Link to="/" className="btn-lift inline-flex rounded-full bg-[#E6007A] px-6 py-3 text-white font-semibold">
          Wróć na stronę główną
        </Link>
      </div>
    </div>
  );
}
